import { FirebaseApp, initializeApp } from 'firebase/app';
import { firebaseEnvironment } from './firebase-environment';

export const firebaseApp: FirebaseApp = initializeApp(firebaseEnvironment);
